// @ts-nocheck
// Bootstrap entry point.

import "./styles/index.css";
import { initI18n } from "./i18n";
import { updateStaticDom } from "./i18n/static-dom";
import { initI18nRemount } from "./i18n/remount";

import { refreshSession } from "./auth/session";
import { initMapRefs } from "./map/state";
import { initHoleDelegation } from "./map/holes";
import { initPanControls } from "./map/pan";
import { update, updateZoomButton } from "./map/camera";
import { buildHomeScene } from "./map/home-scene";
import { initDayNight } from "./map/day-night";
import {
  setInitialBootBounds,
  initBackendSync,
} from "./map/data-sync";
import { initGardenChrome } from "./map/map-loading";
import { resolveInitialBootBounds } from "./map/boot-bounds";
import { initAuthUI } from "./features/auth-flow";
import { initPasswordResetDeepLink } from "./features/password-reset-deep-link";
import { initHeadstoneInviteDeepLink } from "./features/headstone-invite-deep-link";
import { initAds } from "./features/ads";
import { initVerifyEmailDeepLink } from "./features/verify-email-deep-link";
import { initStripeReturn } from "./features/payment-return";
import { initMemorialDeepLink } from "./features/memorial-deep-link";
import { initPostsAccess } from "./features/posts-access";
import { initPostsFeed } from "./features/posts-feed";
import { initPostsDeepLink } from "./features/posts-deep-link";
import { initMemorialTributes } from "./features/memorial-tributes";
import { initGoToMyMemorial } from "./features/go-to-my-memorial";
import { initTempleCatalog } from "./features/memorial-catalog";
import { initViewRouter } from "./features/view-router";
import { initOnboarding, syncOnboardingToSession } from "./features/onboarding";
import { initGardenHeader } from "./features/garden-header";
import { initConsentBanner } from "./components/consent-banner/consent-banner";
import { syncVisualViewportInsets } from "./utils/viewport";
import "./globals";

declare const lucide: any;

// Paint the garden immediately (before i18n) so placeholder tombs appear on first JS tick.
initMapRefs();
syncVisualViewportInsets();
initHoleDelegation();
buildHomeScene();
update({ chunkMode: "sync" });

async function boot(): Promise<void> {
  await initI18n();
  updateStaticDom();
  initI18nRemount();

  await import("./bootstrap");
  initConsentBanner();

  initViewRouter();
  initOnboarding();
  try {
    await refreshSession();
  } catch (err) {
    console.warn("Session refresh failed:", err);
  }
  await syncOnboardingToSession();

  initGardenHeader();
  initPanControls();
  setInitialBootBounds(resolveInitialBootBounds());
  initBackendSync();
  initGardenChrome();

  initTempleCatalog();
  initAuthUI();
  initPasswordResetDeepLink();
  initHeadstoneInviteDeepLink();
  initVerifyEmailDeepLink();
  initStripeReturn();
  initMemorialDeepLink();
  initPostsAccess();
  initPostsFeed();
  initPostsDeepLink();
  initMemorialTributes();
  initGoToMyMemorial();
  initAds();

  if (typeof lucide !== "undefined") lucide.createIcons();

  update();
  updateZoomButton();
  initDayNight();
}

boot();
